import { OwnerController } from './owner.controller';
import template from './owner.html';
import '../../common/ui/userForm/userForm';

export const ownerComponent = {
  name: 'ownerComponent',
  restrict: 'E',
  template,
  controller: OwnerController,
  controllerAs: 'vm',
  bindings: {}
};



// WEBPACK FOOTER //
// ./src/app/components/owner/owner.component.js